import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NeedAssistanceCardComponent } from './components/need-assistance-card/need-assistance-card.component';
import { MaterialModule } from '../material.module';
import { ModuleBlockComponent } from './components/module-block/module-block.component';
import { LoaderComponent } from './components/loader/loader.component';
import { RouterModule } from '@angular/router';
import { AutoFocusDirective } from './directives/auto-focus/auto-focus.directive';
import { OrderPipe } from './components/pipes/order/order.pipe';
import { SelectSchoolComponent } from './components/select-school/select-school.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchSchoolComponent } from './components/search-school/search-school.component';
import { SelectPolicyYearComponent } from './components/select-policy-year/select-policy-year.component';

import { FilterPipe } from './components/pipes/filter/filter.pipe';
import { AlertBoxComponent } from './components/alert-box/alert-box.component';
import { CustomHintComponent } from './components/custom-hint/custom-hint.component';
import { FieldValidationDirective } from './directives/field-validation.directive';
import { CopyPasteDirective } from './directives/copy-paste.directive';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ErrorMessagesComponent } from './components/error-messages/error-messages.component';
import { UnauthorizePageComponent } from './components/unauthorize-page/unauthorize-page.component';
import { PersonalInformationComponent } from './components/personal-information/personal-information.component';
import { AddressInformationComponent } from './components/address-information/address-information.component';
import { CoverageInformationComponent } from './components/coverage-information/coverage-information.component';
import { SavedChangesSuccessComponent } from './components/saved-changes-success/saved-changes-success.component';
//import { NgxMaskModule } from 'ngx-mask';
import { PaginationCommonComponent } from './components/pagination-common/pagination-common.component';
import { SaveChangesComponent } from '../shared/components/saved-changes/saved-changes.component';
import { CurrencyDirective } from './directives/currency.directive';
import { PrintDirective } from './directives/print/print.directive';
import { DateValidationDirective } from './directives/date-validation.directive';
import { PasteDirective } from './directives/paste.directive';
import { SpinnerComponent } from './components/body-spinner/body-spinner.component';
import { TrimDirective } from './directives/trim.directive';
import { AppDateAdapter } from './date.adapter';
import { CsvParserService } from './services/csv-parser.service';
import { DialogService } from './services/dialog.service';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NoticeComponent } from './components/notice/notice.component';

@NgModule({
    declarations: [
        NeedAssistanceCardComponent,
        ModuleBlockComponent,
        LoaderComponent,
        AutoFocusDirective,
        OrderPipe,
        SelectSchoolComponent,
        SearchSchoolComponent,
        FilterPipe,
        AlertBoxComponent,
        SelectPolicyYearComponent,
        CustomHintComponent,
        FieldValidationDirective,
        CopyPasteDirective,
        ErrorPageComponent,
        PageHeaderComponent,
        ErrorMessagesComponent,
        UnauthorizePageComponent,
        PersonalInformationComponent,
        AddressInformationComponent,
        CoverageInformationComponent,
        SavedChangesSuccessComponent, PaginationCommonComponent,
        SaveChangesComponent,
        CurrencyDirective,
        PrintDirective,
        DateValidationDirective,
        PasteDirective,
        SpinnerComponent,
        TrimDirective,
        NoticeComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxPaginationModule,
        NgxMaskDirective
    ],
    exports: [
        NeedAssistanceCardComponent,
        ModuleBlockComponent,
        LoaderComponent,
        AutoFocusDirective,
        SelectSchoolComponent,
        SearchSchoolComponent,
        SelectPolicyYearComponent,
        CustomHintComponent,
        FieldValidationDirective,
        CopyPasteDirective,
        MatDatepickerModule,
        MatNativeDateModule,
        PageHeaderComponent,
        ErrorMessagesComponent,
        PersonalInformationComponent,
        AddressInformationComponent,
        CoverageInformationComponent,
        SavedChangesSuccessComponent,
        PaginationCommonComponent,
        SaveChangesComponent,
        CurrencyDirective,
        PrintDirective,
        DateValidationDirective,
        PasteDirective,
        SpinnerComponent,
        TrimDirective,
        NoticeComponent
    ],
    providers: [provideNgxMask(), DialogService, AppDateAdapter, CsvParserService, TitleCasePipe, OrderPipe, FilterPipe]
})
export class SharedModule { }
